import React, { useEffect, useState } from 'react';
import Divider from '../components/Common/Divider';
import '../css/Colors.css';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingSpinner from '../components/Common/LoadingSpinner';
import WGTor from '../components/WorkingGroups/WGTor';
import WGTeam from '../components/WorkingGroups/WGTeam';
import SGChairDetails from '../components/WorkingGroups/SGChairDetails';
import WGReferenceDocs from '../components/WorkingGroups/WGReferenceDocs';
import './WorkingGroup.css';
import apiHelper from '../utils/apiHelper';

const { FILE_NAMES } = require('../utils/constants');

function SteeringGroup() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [currentGroup, setCurrentGroup] = useState(null);
  const [torData, setTorData] = useState(null);
  const [teamData, setTeamData] = useState(null);
  const [referenceDocsData, setReferenceDocsData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [wgDataResult, torDataResult, teamResult, referenceDocsResult] = await Promise.all([
          apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.WG_STRUCTURE),
          apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.WG_TOR),
          apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.WG_MEMBER_DETAILS),
          apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.WG_REFERENCE_DOCS)
        ]);

        // Get current steering group
        const filteredData = wgDataResult.fileContent.filter(
          group => group.id === parseInt(id) 
        );

        setCurrentGroup(filteredData[0]);
        setTorData(torDataResult.fileContent);

        // Filter team members for this steering group
        const groupMembers = teamResult.fileContent.filter(
          member => member.workingGroupName === filteredData[0]?.workingGroupName
        ).sort((a, b) => {
          if (a.workingGroupPosition === 'Chair') return -1;
          if (b.workingGroupPosition === 'Chair') return 1;
          return a.lastName.localeCompare(b.lastName);
        });
        setTeamData(groupMembers);

        setReferenceDocsData(referenceDocsResult.fileContent);

      } catch (err) {
        console.error('Error fetching data:', err.message);
      }
    };
    fetchData();
  }, [id]);

  const handleGroupClick = (group) => {
    navigate(`/WorkingGroups/WorkingGroup/${group.id}`);
  };

  if (!currentGroup || !torData || !teamData || !referenceDocsData) {
    return <LoadingSpinner />;
  }

  return (
    <div className='totalPage'>
      <section className="wrapper">
        <div className="container mt-6 pb-6">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <h2 className="text-uppercase main-header">{currentGroup.workingGroupName}</h2>
            <div>
              <button
                onClick={() => window.history.back()}
                className="btn btn-primary"
              >
                <i className="fas fa-arrow-left"></i> Back
              </button>
            </div>
          </div>
        </div>

        <div className="container">
          <SGChairDetails currentGroup={currentGroup} />
        </div>

        <Divider height={60} />

        <section className="wrapper bg-gradient-primary">
          <div className="container">
            <h2 className="text-uppercase main-header">Terms of Reference</h2>
          </div>
          <div className="container mt-10">
            <WGTor 
              currentGroup={currentGroup} 
              torData={torData}
            />
          </div>
        </section>

        <Divider height={60} />

        <section className="wrapper bg-gradient-primary">
          <div className="container pb-6">
            <h2 className="text-uppercase main-header">Meet the Team</h2>
          </div>
          <div className="container">
            <WGTeam data={teamData} />
          </div>
        </section>

        <Divider height={60} />

        <section className="wrapper bg-gradient-primary pb-12">
          <div className="container pb-6">
            <h2 className="text-uppercase main-header">Reference Documents</h2>
          </div>
          <div className="container">
            <WGReferenceDocs data={referenceDocsData} />
          </div>
        </section>
      </section>
    </div>
  );
}

export default SteeringGroup;